import { ValueOf } from "./utils";

export const DELIVERY_TYPE = {
    CARRYON_POST: "CARRYON_POST",
    CARRYON_POST_BRING: "CARRYON_POST_BRING",
    CARRYON_EXP: "CARRYON_EXP",
    CARRYON_EXP_JUL: "CARRYON_EXP_JUL",
    CARRYON_DOOR: "CARRYON_DOOR",
    PICK_UP_IN_SHOP: "PICK_UP_IN_SHOP",
    PICK_UP_POINT: "PICK_UP_POINT",
    PICK_UP_POINT_BRING: "PICK_UP_POINT_BRING",
    LETTER: "LETTER",
    BUSN_PRC: "BUSN_PRC",
    PROGRESS_BAR: "PROGRESS_BAR",
} as const;

export type DeliveryType = ValueOf<typeof DELIVERY_TYPE>;
export const DELIVERY_NOTE_DEFAULT_MAX_LENGTH = 100;
export const DELIVERY_TYPES_WITH_DELIVERY_NOTE: readonly string[] = [
    DELIVERY_TYPE.CARRYON_EXP,
    DELIVERY_TYPE.CARRYON_EXP_JUL,
] as const;
export const DELIVERY_TYPES_FOR_PREOWNED = [
    DELIVERY_TYPE.CARRYON_POST,
    DELIVERY_TYPE.CARRYON_POST_BRING,
    DELIVERY_TYPE.PICK_UP_POINT,
] as const;
export const DELIVERY_TYPES_WITH_CODE = [DELIVERY_TYPE.PICK_UP_IN_SHOP, DELIVERY_TYPE.PICK_UP_POINT] as const;
